import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../localStorage/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class HolidaycalenderService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //  window.alert(errorMessage);
    return throwError(errorMessage);
  }

  // Create holidays
  createHolidays(addcclrdata: Object): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/holidays`, addcclrdata).pipe(catchError(this.handleError));
  }

  // Get holidays by Id Get
  getHolidays(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/holidays/${id}`).pipe(catchError(this.handleError));
  }

  //Delete holidays by Id Delete
  deleteHolidays(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/holidays/${id}`).pipe(catchError(this.handleError));
  }

  //Update holidays by Id Put
  updateHolidays(user: Object, id: number): Observable<Object> {
    return this.http.put(`${environment.apiUrl}/holidays/${id}`, user).pipe(catchError(this.handleError));
  }

  //Get All holidays
  getAllHolidays(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/holidays`).pipe(catchError(this.handleError));
  }

  //Get All Annual Holidays
  getAllAnnualHolidays(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/holidays?optionalHolidays=false`).pipe(catchError(this.handleError));
  }

  //Get All Annual Holidays
  getAllOptionalHolidays(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/holidays?optionalHolidays=true`).pipe(catchError(this.handleError));
  }

  //Get All holidays by Year
  getAllHolidaysByYear(year: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/holidays?year=${year}`).pipe(catchError(this.handleError));
  }

  //Get All Optional holidays by Year
  getAllOptionalHolidaysByYear(year: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/holidays?year=${year}&optionalHolidays=true`).pipe(catchError(this.handleError));
  }

  //Get All Annual holidays by Year
  getAllAnnualHolidaysByYear(year: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/holidays?year=${year}&optionalHolidays=false`).pipe(catchError(this.handleError));
  }

  getHolidaysCustomColumn(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/customColumns/tableName=holidays`).pipe(catchError(this.handleError));
  }

  createCustomColumn(colData): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/customColumns`, colData).pipe(catchError(this.handleError));
  }
}
